import {
  daysOfWeek,
  IWeekWorkTime,
  WeekDaysEnum,
} from 'features/working-hours-picker/interfaces/time-table-input.interface';
import React from 'react';
import styles from './work-days-dropdown.module.scss';

interface WorkDaysDropdownProps {
  options: IWeekWorkTime;
  isOpen?: boolean;
}

// Функция для преобразования WeekDaysEnum в ключи IWorkingTime
const getDayKey = (day: WeekDaysEnum): string => {
  switch (day) {
    case WeekDaysEnum.Пн:
      return 'monday';
    case WeekDaysEnum.Вт:
      return 'tuesday';
    case WeekDaysEnum.Ср:
      return 'wednesday';
    case WeekDaysEnum.Чт:
      return 'thursday';
    case WeekDaysEnum.Пт:
      return 'friday';
    case WeekDaysEnum.Сб:
      return 'saturday';
    case WeekDaysEnum.Вс:
      return 'sunday';
    default:
      return '';
  }
};

export const WorkDaysDropdown: React.FC<WorkDaysDropdownProps> = ({
  options,
  isOpen = true,
}) => {
  const selectedId = new Date().getDay() - 1;
  const weekWorkTime = daysOfWeek.map((day) => {
    const dayKey = getDayKey(day);
    const time = options[dayKey];

    if (time?.start === null && time?.end === null) {
      return `${day.toLowerCase()}: выходной`;
    } else if (time?.start === '00:00' && time?.end === '00:00') {
      return `${day.toLowerCase()}: 24 часа`;
    }

    const startTime = time?.start || '--:--';
    const endTime = time?.end || '--:--';

    return `${day.toLowerCase()}: ${startTime} - ${endTime}`;
  });

  return (
    <div
      className={`${styles.dropdown_container} ${
        isOpen ? styles.dropdown_open : ''
      }`}
    >
      <div className={styles.dropdown_list}>
        {weekWorkTime.map((timeString, index) => (
          <div
            key={`${timeString}-${index}`}
            className={`${styles.dropdown_item} ${
              index === selectedId ? styles.dropdown_item_selected : ''
            }`}
          >
            {timeString}
          </div>
        ))}
      </div>
    </div>
  );
};
